import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    loadMeldungVersFallGwrkListStatus: 'idle',
    loadMeldungVersFallGwrkListError: undefined as any,
    loadMeldungVersFallGwrkListLastArgs: undefined as any,
    loadMeldungVersFallGwrkStatus: 'idle',
    loadMeldungVersFallGwrkError: undefined as any,
    saveMeldungVersFallGwrkStatus: 'idle',
    saveMeldungVersFallGwrkError: undefined as any,
    deleteMeldungVersFallGwrkStatus: 'idle',
    deleteMeldungVersFallGwrkError: undefined as any,

    meldungVersFallGwrkList: [] as any[],
    formItem: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const loadMeldungVersFallGwrkList = createAsyncThunk('meldungVersFallGwrkSlice/loadMeldungVersFallGwrkList', async ({ forceReload }: any, { rejectWithValue, getState }: any) => {
    const lastArgs = getState().meldungVersFallGwrkSlice.loadMeldungVersFallGwrkListLastArgs
    if (_.isEqual(lastArgs, {  }) && !forceReload) { return }

    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldversfallgwrk/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
        args: {  }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungVersFallGwrkListStatus } = getState().meldungVersFallGwrkSlice
        return loadMeldungVersFallGwrkListStatus !== 'pending'
    }
})

export const loadMeldungVersFallGwrk = createAsyncThunk('meldungVersFallGwrkSlice/loadMeldungVersFallGwrk', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/nurismeldversfallgwrk/?action=eql&HDR_ID=${id}`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadMeldungVersFallGwrkStatus } = getState().meldungVersFallGwrkSlice
        return loadMeldungVersFallGwrkStatus !== 'pending'
    }
})

export const saveMeldungVersFallGwrk = createAsyncThunk('meldungVersFallGwrkSlice/saveMeldungVersFallGwrk', async ({ meldungVersFallGwrk }: any, { rejectWithValue }: any) => {
    let promises = []
    if (meldungVersFallGwrk?.HDR_ID) {
        promises.push(client.put(
            `/api/ixweb/nurismeldversfallgwrk/${ meldungVersFallGwrk?.HDR_ID }/`,
            prepareData(meldungVersFallGwrk),
        ))
    } else {
        promises.push(client.post(
            `/api/ixweb/nurismeldversfallgwrk/`,
            prepareData(meldungVersFallGwrk),
        ))
    }

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue, true)

    return {
        data: {
            ...value1,
        }
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { saveMeldungVersFallGwrkStatus } = getState().meldungVersFallGwrkSlice
        return saveMeldungVersFallGwrkStatus !== 'pending'
    }
})

export const deleteMeldungVersFallGwrk = createAsyncThunk('meldungVersFallGwrkSlice/deleteMeldungVersFallGwrk', async ({ id }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.delete(
        `/api/ixweb/nurismeldversfallgwrk/${id}/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: id,
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { deleteMeldungVersFallGwrkStatus } = getState().meldungVersFallGwrkSlice
        return deleteMeldungVersFallGwrkStatus !== 'pending'
    }
})

const MeldungVersFallGwrkSlice = createSlice({
    name: 'meldungVersFallGwrkSlice',
    initialState,
    reducers: {
        resetloadMeldungVersFallGwrkListError: (state) => {
            state.loadMeldungVersFallGwrkListError = undefined
        },
        resetloadMeldungVersFallGwrk: (state) => {
            state.formItem = undefined
            state.loadMeldungVersFallGwrkError = undefined
        },
        resetloadMeldungVersFallGwrkError: (state) => {
            state.loadMeldungVersFallGwrkError = undefined
        },
        resetsaveMeldungVersFallGwrk: (state) => {
            state.formItem = undefined
            state.saveMeldungVersFallGwrkError = undefined
        },
        resetsaveMeldungVersFallGwrkError: (state) => {
            state.saveMeldungVersFallGwrkError = undefined
        },
        resetdeleteMeldungVersFallGwrkError: (state) => {
            state.deleteMeldungVersFallGwrkError = undefined
        },
        removeFromMeldungVersFallGwrkListById: (state, action) => {
            state.meldungVersFallGwrkList = state.meldungVersFallGwrkList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromMeldungVersFallGwrkListByIds: (state, action) => {
            state.meldungVersFallGwrkList = state.meldungVersFallGwrkList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.meldungVersFallGwrkList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.loadMeldungVersFallGwrkListStatus = 'preloaded'
            state.loadMeldungVersFallGwrkListLastArgs = ''
        },
        clearPreloadedData: (state) => {
            state.meldungVersFallGwrkList = []
            state.loadMeldungVersFallGwrkListStatus = 'idle'
            state.loadMeldungVersFallGwrkListLastArgs = undefined
        },
    },
    extraReducers: builder => {
        builder.addCase(loadMeldungVersFallGwrkList.pending, (state) => {
            state.loadMeldungVersFallGwrkListStatus = 'pending'
            state.loadMeldungVersFallGwrkListError = undefined
        })
        builder.addCase(loadMeldungVersFallGwrkList.fulfilled, (state, action) => {
            state.loadMeldungVersFallGwrkListStatus = 'idle'

            if (!action.payload) { return }

            state.loadMeldungVersFallGwrkListLastArgs = action.payload.args

            {
                state.meldungVersFallGwrkList = action.payload.data

            }
        })
        builder.addCase(loadMeldungVersFallGwrkList.rejected, (state, action) => {
            state.loadMeldungVersFallGwrkListStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungVersFallGwrkListError = action.error.message
            } else {
                state.loadMeldungVersFallGwrkListError = action.payload
            }
        })

        builder.addCase(loadMeldungVersFallGwrk.pending, (state) => {
            state.loadMeldungVersFallGwrkStatus = 'pending'
            state.loadMeldungVersFallGwrkError = undefined
        })
        builder.addCase(loadMeldungVersFallGwrk.fulfilled, (state, action) => {
            state.loadMeldungVersFallGwrkStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungVersFallGwrkList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungVersFallGwrkList.push(newItem) }
                else { state.meldungVersFallGwrkList[i] = { ...state.meldungVersFallGwrkList[i], ...newItem } }
            }
        })
        builder.addCase(loadMeldungVersFallGwrk.rejected, (state, action) => {
            state.loadMeldungVersFallGwrkStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadMeldungVersFallGwrkError = action.error.message
            } else {
                state.loadMeldungVersFallGwrkError = action.payload
            }
        })

        builder.addCase(saveMeldungVersFallGwrk.pending, (state) => {
            state.saveMeldungVersFallGwrkStatus = 'pending'
            state.saveMeldungVersFallGwrkError = undefined
        })
        builder.addCase(saveMeldungVersFallGwrk.fulfilled, (state, action) => {
            state.saveMeldungVersFallGwrkStatus = 'idle'

            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                state.formItem = newItem
            }
            {
                const newItem = Array.isArray(action.payload.data) ? action.payload.data[0] : action.payload.data
                const i = state.meldungVersFallGwrkList.findIndex((x: any) => x.HDR_ID === newItem.HDR_ID)
                if (i === -1) { state.meldungVersFallGwrkList.push(newItem) }
                else { state.meldungVersFallGwrkList[i] = { ...state.meldungVersFallGwrkList[i], ...newItem } }
            }
        })
        builder.addCase(saveMeldungVersFallGwrk.rejected, (state, action) => {
            state.saveMeldungVersFallGwrkStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.saveMeldungVersFallGwrkError = action.error.message
            } else {
                state.saveMeldungVersFallGwrkError = action.payload
            }
        })

        builder.addCase(deleteMeldungVersFallGwrk.pending, (state) => {
            state.deleteMeldungVersFallGwrkStatus = 'pending'
            state.deleteMeldungVersFallGwrkError = undefined
        })
        builder.addCase(deleteMeldungVersFallGwrk.fulfilled, (state, action) => {
            state.deleteMeldungVersFallGwrkStatus = 'idle'

            {
                if (Array.isArray(action.payload.data)) {
                    state.meldungVersFallGwrkList = state.meldungVersFallGwrkList.filter((x: any) => !action.payload.data.includes(x.HDR_ID))
                } else {
                    state.meldungVersFallGwrkList = state.meldungVersFallGwrkList.filter((x: any) => x.HDR_ID !== action.payload.data)
                }
            }
        })
        builder.addCase(deleteMeldungVersFallGwrk.rejected, (state, action) => {
            state.deleteMeldungVersFallGwrkStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.deleteMeldungVersFallGwrkError = action.error.message
            } else {
                state.deleteMeldungVersFallGwrkError = action.payload
            }
        })

    }
})

export const {
    resetloadMeldungVersFallGwrkListError,
    resetloadMeldungVersFallGwrk,
    resetloadMeldungVersFallGwrkError,
    resetsaveMeldungVersFallGwrk,
    resetsaveMeldungVersFallGwrkError,
    resetdeleteMeldungVersFallGwrkError,
    removeFromMeldungVersFallGwrkListById,
    removeFromMeldungVersFallGwrkListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = MeldungVersFallGwrkSlice.actions
export default MeldungVersFallGwrkSlice.reducer
